import { trpcClient } from "@/lib/trpc";
import { env } from "@papier/env/env-frontend";

export async function uploadOrganizationLogo(file: File) {
  const presignedData = await trpcClient.assets.getOrganizationLogoPresignedUploadUrl.mutate({
    filename: file.name,
    mimeType: file.type,
  });

  // Upload to R2 using presigned URL
  const uploadResponse = await fetch(presignedData.uploadUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type,
    },
  });

  if (!uploadResponse.ok) {
    throw new Error("Failed to upload organization logo");
  }

  // Complete upload (moves from temp to final location and updates DB)
  const result = await trpcClient.assets.completeOrganizationLogoUpload.mutate({
    uploadKey: presignedData.uploadKey,
  });

  // Return the CDN URL using the imageKey from the result
  return `${env.VITE_CDN_PATH}/${result.imageKey}`;
}

export async function getUserAvatarUrl(file: File) {
  const presignedData = await trpcClient.assets.getAvatarPresignedUploadUrl.mutate({
    filename: file.name,
    mimeType: file.type,
  });

  const uploadResponse = await fetch(presignedData.uploadUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type,
    },
  });

  if (!uploadResponse.ok) {
    throw new Error("Failed to upload avatar");
  }

  const result = await trpcClient.assets.getAvatarUploadUrl.mutate({
    uploadKey: presignedData.uploadKey,
  });

  // Return the url as the uploading is done on the frontend
  return result.imageKey;
}
